"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setChannelName = void 0;
var setChannelName = function (channel, name) {
    Object.defineProperty(channel, 'name', { value: name, writable: false, configurable: true, enumerable: false });
};
exports.setChannelName = setChannelName;
